import React from 'react'

import './App.scss'

import Carousel from './Carousel'

import gallery from './gallery.json'

const App = () => {
  
  return (
    <div className="App">
      <header className="App-header">
      </header>
      <main>
        <Carousel gallery={ gallery }/>
      </main>
    </div>
  );
}

export default App
